import { Component, OnInit } from '@angular/core';
import { LendioAngularMaterialThemeService } from '../../../lendio-angular-material-theme/lendio-angular-material-theme.service';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './application-details-resolver.component.html',
})
export class ApplicationDetailsResolverComponent implements OnInit {
  newThemeActive$: Observable<boolean>;

  constructor(private _themeService: LendioAngularMaterialThemeService) {}

  ngOnInit(): void {
    this.newThemeActive$ = this._themeService.enabled;
  }
}
